<template>
	<v-main>
		<v-container fluid>
			<FormPage
				title="Simulatore “e se”"
				subtitle="Prova uno sconto, un nuovo prezzo o la spedizione gratis prima di farlo davvero"
				:back-label="backLabel"
				save-label="Crea questa promo"
				:save-disabled="!puoCreare"
				@back="back"
				@save="creaPromo"
			>
				<v-row>
					<v-col cols="12" md="5">
						<SimulatorForm v-model="form" :categorie="categorie" :marche="marche" :current-price="result && result.currentPrice" />
					</v-col>
					<v-col cols="12" md="7">
						<SimulatorResult :result="result" :loading="loading" />
						<div v-if="form.lever === 'shipping'" class="sim-muted mt-2">La spedizione gratis non è un'offerta: la soglia si imposta nei metodi di spedizione.</div>
						<div v-else-if="result && result.discount < 0" class="sim-muted mt-2">Un aumento di prezzo si fa dalla scheda prodotto, non con un'offerta.</div>
					</v-col>
				</v-row>
			</FormPage>
		</v-container>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FormPage from '@/components/core/FormPage.vue';
import { childPage } from '@/components/core/childPage';
import { openWithReturn } from '@/components/core/pageReturn';
import { Category } from '@/utils/Category';
import SimulatorForm from '@/components/insights/simulator/SimulatorForm.vue';
import SimulatorResult from '@/components/insights/simulator/SimulatorResult.vue';

const LEVE = ['discount', 'price', 'shipping'];
const GIORNI_OK = [7, 14, 30, 60];
const lista = v => (v ? String(v).split('|') : []);

/**
 * Stato del simulatore dall'URL: cosi' la freccia di "Crea questa promo" lo ritrova com'era.
 * Accetta anche il link dei Consigli (?item=&sku=&title=&discount=).
 */
const formDaQuery = q => {
	const ids = q.items ? lista(q.items) : q.item ? [String(q.item)] : [];
	const skus = q.skus !== undefined ? lista(q.skus) : q.sku ? [String(q.sku)] : [];
	const titoli = q.titles !== undefined ? lista(q.titles) : q.title ? [String(q.title)] : [];
	return {
		lever: LEVE.includes(q.lever) ? q.lever : 'discount',
		amount: Number(q.amount || q.discount) || 10,
		days: GIORNI_OK.includes(Number(q.days)) ? Number(q.days) : 14,
		scopeType: ['items', 'category', 'brand'].includes(q.scope) ? q.scope : q.category ? 'category' : q.brand ? 'brand' : 'items',
		items: ids.map((id, i) => ({ _id: id, sku: skus[i] || '', name: `${titoli[i] || ''} ${skus[i] || ''}`.trim() || 'Prodotto' })),
		category: q.category || null,
		brand: q.brand || null,
	};
};

const formInQuery = f => {
	const q = { lever: f.lever, amount: String(f.amount), days: String(f.days), scope: f.scopeType };
	if (f.scopeType === 'items' && f.items.length) {
		q.items = f.items.map(i => i._id).join('|');
		q.skus = f.items.map(i => i.sku || '').join('|');
		q.titles = f.items.map(i => (i.sku ? i.name.replace(i.sku, '') : i.name).trim()).join('|');
	}
	if (f.scopeType === 'category' && f.category) q.category = f.category;
	if (f.scopeType === 'brand' && f.brand) q.brand = f.brand;
	return q;
};

// Simulatore "e se" (/insights/simulator): aperto dai Consigli torna li'; lo stato del form vive nell'URL
export default {
	name: 'InsightsSimulator',
	components: { FormPage, SimulatorForm, SimulatorResult },
	mixins: [childPage({ listPath: '/insights', kind: 'simulation' })],
	data() {
		return {
			form: formDaQuery(this.$route.query || {}),
			result: null,
			loading: false,
			categorie: [],
			marche: [],
			richiesta: 0,
		};
	},
	computed: {
		...mapGetters({ getSettings: 'settings/getSetting' }),
		payload() {
			const f = this.form;
			const scope = f.scopeType === 'items' ? { type: 'items', ids: f.items.map(i => i._id) } : { type: f.scopeType, id: f.scopeType === 'category' ? f.category : f.brand };
			return { lever: { type: f.lever, value: Number(f.amount) }, days: f.days, scope };
		},
		pronto() {
			const f = this.form;
			if (!(Number(f.amount) > 0)) return false;
			if (f.lever === 'shipping') return true;
			if (f.lever === 'discount' && Number(f.amount) > 90) return false;
			if (f.scopeType === 'items') return f.items.length > 0;
			return !!(f.scopeType === 'category' ? f.category : f.brand);
		},
		puoCreare() {
			return !!(this.result && !this.result.empty && this.form.lever !== 'shipping' && this.result.discount > 0);
		},
	},
	watch: {
		payload: {
			deep: true,
			handler() {
				this.simulaDopo();
			},
		},
		// replace e non push: la freccia del browser non deve ripassare da ogni tasto premuto
		form: {
			deep: true,
			handler(f) {
				const query = { ...formInQuery(f), ...(this.$route.query.from ? { from: this.$route.query.from } : {}) };
				if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {});
			},
		},
	},
	async mounted() {
		this.caricaContesto().catch(err => console.log(err));
		if (this.pronto) this.simula();
	},
	created() {
		this.simulaDopo = _.debounce(this.simula, 400);
	},
	methods: {
		...mapActions({ simulate: 'insights/simulate', getProfile: 'profile/getProfile', fetchLists: 'brands/fetchLists' }),
		// marche e albero categorie nella lingua predefinita, come le schede offerta e coupon
		async caricaContesto() {
			await this.getProfile();
			const lang = (_.find(this.getSettings.languages, { default: true }) || {}).lang || 'it';
			const listBrand = await this.fetchLists();
			this.marche = _.orderBy(
				_.map(listBrand.data, b => ({ _id: b._id, name: (_.find(b.trans, { lang }) || {}).name || '' })),
				['name'],
				['asc'],
			);
			const category = new Category(this.getSettings.categories, lang);
			await category.build();
			await category.refactorCategory();
			await category.createPath();
			await category.dynamicSort();
			this.categorie = await category.getTree;
		},
		async simula() {
			if (!this.pronto) {
				this.result = null;
				return;
			}
			const n = ++this.richiesta;
			this.loading = true;
			try {
				const data = await this.simulate(this.payload);
				// risponde solo l'ultima richiesta: chi scrive veloce non vede risultati vecchi
				if (n === this.richiesta) this.result = data;
			} catch (err) {
				if (n === this.richiesta) {
					this.result = null;
					const res = err.response;
					this.notify('error', (res && res.data && res.data.message) || err.message);
				}
			} finally {
				if (n === this.richiesta) this.loading = false;
			}
		},
		// la nuova offerta si apre gia' compilata; la sua freccia riporta qui
		creaPromo() {
			if (!this.puoCreare) return;
			const f = this.form;
			const query = { discount: Math.round(this.result.discount), name: 'Offerta speciale' };
			if (f.scopeType === 'items') {
				query.items = f.items.map(i => i._id).join(',');
				query.skus = f.items.map(i => i.sku || '').join(',');
			} else if (f.scopeType === 'category') query.category = f.category;
			else query.brand = f.brand;
			openWithReturn(this, { path: '/ecommerce/offers/new', query }, { label: 'Torna al simulatore' });
		},
	},
};
</script>

<style scoped>
.sim-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
